/* import __COLOCATED_TEMPLATE__ from './index.hbs'; */
import Component from '@glimmer/component';
import { action } from '@ember/object';
import { type IExtra } from 'uplisting-frontend/components/ui/filters/filter/multi-select';

interface IArgs {
  option: string;
  extra: IExtra;
  shouldTranslate?: boolean;
  filterId?: string;
}

interface FiltersFilterMultiSelectListSelectedSignature {
  Element: null;

  Args: IArgs;
}

export default class FiltersFilterMultiSelectListSelectedComponent extends Component<FiltersFilterMultiSelectListSelectedSignature> {
  @action
  handleReset(): void {
    this.args.extra.handleChange(null);
  }
}

declare module '@glint/environment-ember-loose/registry' {
  export default interface Registry {
    'Ui::Filters::Filter::MultiSelectList::Selected': typeof FiltersFilterMultiSelectListSelectedComponent;
    'ui/filters/filter/multi-select-list/selected': typeof FiltersFilterMultiSelectListSelectedComponent;
  }
}
